import React, { useEffect, useState } from "react";
import api, { money } from "../lib/api";

const fmtAddr = (a) => a ? `${a.street || ""}, ${a.number || ""}${a.complement ? " " + a.complement : ""} — ${a.city || ""}/${a.state || ""} — CEP ${a.cep || ""}` : "—";

export default function AdminCustomers() {
  const [data, setData] = useState({ registered: [], guests: [] });

  useEffect(() => {
    api.get("/admin/customers").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const Table = ({ rows, kind }) => (
    <div className="border border-white/10 rounded-lg overflow-x-auto mb-12">
      <table className="w-full text-sm min-w-[860px]" data-testid={`customers-table-${kind}`}>
        <thead className="bg-white/5 text-zinc-400 text-xs uppercase tracking-wider">
          <tr>
            <th className="text-left px-5 py-3">Nome</th>
            <th className="text-left px-5 py-3">E-mail</th>
            <th className="text-left px-5 py-3">WhatsApp</th>
            <th className="text-left px-5 py-3">Endereço (último usado)</th>
            <th className="text-left px-5 py-3">Pedidos</th>
            <th className="text-left px-5 py-3">Total gasto</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c, i) => {
            const phone = (c.phone || "").replace(/\D/g, "");
            return (
              <tr key={c.id || c.email || i} className="border-t border-white/5" data-testid={`customer-row-${i}`}>
                <td className="px-5 py-3.5 text-zinc-200">{c.name}</td>
                <td className="px-5 py-3.5 text-zinc-400">{c.email}</td>
                <td className="px-5 py-3.5" data-testid="customer-phone">
                  {phone ? (
                    <a href={`https://wa.me/55${phone}`} target="_blank" rel="noopener noreferrer"
                      className="text-emerald-400 hover:text-emerald-300 transition-colors">{c.phone}</a>
                  ) : <span className="text-zinc-600">—</span>}
                </td>
                <td className="px-5 py-3.5 text-zinc-400 text-xs max-w-[280px]" data-testid="customer-address">{fmtAddr(c.address)}</td>
                <td className="px-5 py-3.5 text-zinc-300">{c.orders}</td>
                <td className="px-5 py-3.5 text-gold">{money(c.total_spent)}</td>
              </tr>
            );
          })}
          {rows.length === 0 && <tr><td colSpan={6} className="px-5 py-8 text-center text-zinc-600">Nenhum cliente.</td></tr>}
        </tbody>
      </table>
    </div>
  );

  return (
    <div data-testid="admin-customers">
      <h1 className="font-display text-3xl tracking-tight mb-10">Clientes</h1>
      <p className="label-caps mb-4">Cadastrados</p>
      <Table rows={data.registered} kind="registered" />
      <p className="label-caps mb-4">Convidados (compraram sem login)</p>
      <Table rows={data.guests} kind="guests" />
    </div>
  );
}
